import { render, staticRenderFns } from "./NormalSearchNav277.vue?vue&type=template&id=5aa0480f&scoped=true"
import script from "./NormalSearchNav277.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav277.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa0480f",
  null
  
)

export default component.exports